import { boot } from 'quasar/wrappers';
import filters from 'src/utils/filters';
import useEmitter from 'src/utils/emitter';
import library from 'src/utils/library';
import { pluginNames } from 'src/plugins';
const emitter = useEmitter();
// Anonther Boot Hook.
export default boot(async ({ app }) => {
    app.config.globalProperties.$emitter = emitter;
    app.config.globalProperties.$filters = filters;
    app.config.globalProperties.$library = library;
    app.config.globalProperties.$pluginNames = pluginNames;
});
